import { render } from "./aCard.vue?vue&type=template&id=19a95bb2&ts=true"
import script from "./aCard.vue?vue&type=script&lang=ts"
export * from "./aCard.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__